var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeleteRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M19.6433 9.48728C19.6433 9.55528 19.1104 16.296 18.806 19.1329C18.6154 20.8739 17.493 21.9298 15.8095 21.9598C14.516 21.9888 13.2498 21.9988 12.0039 21.9988C10.6813 21.9988 9.38778 21.9888 8.13221 21.9598C6.50513 21.9208 5.38183 20.8439 5.20094 19.1329C4.88778 16.286 4.36454 9.55528 4.35482 9.48728C4.34509 9.28229 4.41123 9.0873 4.54544 8.9293C4.67771 8.78331 4.86833 8.69531 5.06867 8.69531H18.9392C19.1386 8.69531 19.3195 8.78331 19.4624 8.9293C19.5957 9.0873 19.6628 9.28229 19.6433 9.48728Z",
    fill: "#FA4A4A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21 5.97686C21 5.56588 20.6761 5.24389 20.2871 5.24389H17.3714C16.7781 5.24389 16.2627 4.8219 16.1304 4.22692L15.967 3.49795C15.7385 2.61698 14.9498 2 14.0647 2H9.93624C9.0415 2 8.26054 2.61698 8.02323 3.54595L7.87054 4.22792C7.7373 4.8219 7.22185 5.24389 6.62957 5.24389H3.71385C3.32386 5.24389 3 5.56588 3 5.97686V6.35685C3 6.75783 3.32386 7.08982 3.71385 7.08982H20.2871C20.6761 7.08982 21 6.75783 21 6.35685V5.97686Z",
    fill: "#FA4A4A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteRed);
export default __webpack_public_path__ + "static/media/Delete-red.8877434624de55c52ec2587336933440.svg";
export { ForwardRef as ReactComponent };